import axios from '@/api/config'
import {
  loginAPI,
  confirmLoginAPI,
  loginWithNumberAPI,
  confirmLoginWithNumberAPI,
  logoutAPI,
  refreshTokenAPI,
  myProfileAPI,
  firstPracticedAPI,
  fullfillDataAPI,
  updateAPI,
  getAvatarAPI
} from '@/api/authAPI'
import router from '@/router/index'
import { Alert, Confirm } from 'vue-m-dialog'
import i18n from '@/i18n'
import { remove, getUser } from '@/util/localStorage'

const state = {
  currentUser: {
    id: localStorage.getItem('id') || '',
    name: localStorage.getItem('name') || '',
    userNumber: localStorage.getItem('userNumber') || '',
    email: null,
    emailVerifiedAt: null,
    lastLoginAt: null,
    chineseName: '',
    englishName: null,
    gradeId: localStorage.getItem('gradeId') || '',
    contactPhone: null,
    contactWechat: null,
    contactEmail: null,
    avatar: null,
    avatarFile: null,
    birthday: null,
    parentName: null,
    hasFilledUserInfo: null,
    notificationOn: false,
    notificationSound: '',
    expiryDate: null,
    lastPractice: null,
    continuePractice: null,
    allowSpeechInput: false,
    isUpgraded: false
  },
  token: localStorage.getItem('token') || '',
  loginTime: localStorage.getItem('loginTime') || '',
  loginEngaging: false
}

const getters = {
  getToken (state) {
    if ((state.token) != null) {
      return state.token
    }
    return '0'
  },
  getBasicInfo (state) {
    if ((state.token) != null) {
      return state.currentUser
    }
    return null
  },
  isLogin (state) {
    return !!state.token
  }
}

const mutations = {
  update (state, data) {
    state.currentUser.name = state.currentUser.chineseName + ' ' + data.englishName
    state.currentUser.englishName = data.englishName
    state.currentUser.parentName = data.parentName
    state.currentUser.contactEmail = data.contactEmail
    state.currentUser.contactWechat = data.contactWechat
    state.currentUser.notificationOn = data.notificationOn
    state.currentUser.notificationSound = data.notificationSound
  },
  setAllowSpeechInput (state, flag) {
    state.currentUser.allowSpeechInput = flag
  },
  set (state, data) {
    // console.log('called:', data)
    var expdate = new Date(data.expiry_date)
    var expdatetext = expdate.getFullYear() +
    i18n.t('Common.year') +
    (expdate.getMonth() + 1) +
    i18n.t('Common.month') +
    (expdate.getDate()) +
    i18n.t('Common.day')
    var birthday = new Date(data.birthday)
    var birthdaytext = birthday.getFullYear() +
    i18n.t('Common.year') +
    (birthday.getMonth() + 1) +
    i18n.t('Common.month') +
    (birthday.getDate()) +
    i18n.t('Common.day')
    state.currentUser.name = data.name
    state.currentUser.id = data.id
    state.currentUser.email = data.email
    state.currentUser.userNumber = data.user_number
    state.currentUser.chineseName = data.chinese_name
    state.currentUser.englishName = data.english_name
    state.currentUser.contactPhone = data.contact_phone
    state.currentUser.contactWechat = data.contact_wechat
    state.currentUser.contactEmail = data.contact_email
    state.currentUser.birthday = birthdaytext
    state.currentUser.parentName = data.parent_name
    state.currentUser.notificationOn = data.notification_on
    state.currentUser.notificationSound = data.notification_sound
    state.currentUser.allowSpeechInput = data.allow_speech_input
    state.currentUser.gradeId = data.grade_id
    state.currentUser.isUpgraded = data.is_upgraded
    state.currentUser.expiryDate = expdatetext
  },
  reset (state) {
    state.currentUser.id = null
    state.currentUser.name = null
    state.currentUser.userNumber = null
    state.currentUser.email = null
    state.currentUser.lastLoginAt = null
    state.currentUser.chineseName = null
    state.currentUser.englishName = null
    state.currentUser.gradeId = null
    state.currentUser.contactPhone = null
    state.currentUser.contactWechat = null
    state.currentUser.contactEmail = null
    state.currentUser.avatar = null
    state.currentUser.avatarFile = null
    state.currentUser.birthday = null
    state.currentUser.parentName = null
    state.currentUser.hasFilledUserInfo = null
    state.currentUser.notificationOn = false
    state.currentUser.notificationSound = null
    state.currentUser.expiryDate = null
    state.currentUser.lastPractice = null
    state.currentUser.continuePractice = null
    state.token = null
    state.loginTime = null
    remove()
  },
  resetEdit (state) {
    state.currentUser.email = null
    state.currentUser.parentName = null
    state.currentUser.englishName = null
    state.currentUser.chineseName = null
    state.currentUser.notificationOn = false
    state.currentUser.notificationSound = null
    state.currentUser.contactWechat = null
    state.currentUser.contactEmail = null
  },
  setToken (state, token) {
    state.token = 'Bearer ' + token
    localStorage.token = 'Bearer ' + token
  },
  afterLogin (state, data) {
    localStorage.name = data.name
    localStorage.id = data.id
    localStorage.gradeId = data.grade_id
    localStorage.loginTime = new Date(data.login_time.replace(/-/g, '/').replace(/(\.\d+)?/g, '')).valueOf()
    localStorage.lastPractice = new Date(data.last_practice.replace(/-/g, '/').replace(/(\.\d+)?/g, '')).valueOf()
    localStorage.continuePractice = data.continue_practice
    localStorage.practicedToday = (new Date().getTime() - new Date(parseInt(localStorage.lastPractice)).getTime()) / 1000 < 86400
    localStorage.refreshTime = new Date().getTime()
    localStorage.expiryDate = new Date(data.expiry_date.replace(/-/g, '/').replace(/(\.\d+)?/g, '')).valueOf()
    state.currentUser.name = data.name
    state.currentUser.id = data.id
    state.currentUser.gradeId = data.grade_id
    state.currentUser.lastPractice = new Date(data.last_practice.replace(/-/g, '/').replace(/(\.\d+)?/g, '')).valueOf()
    state.currentUser.continuePractice = data.continue_practice
    state.currentUser.expiryDate = localStorage.expiryDate
    state.loginTime = new Date(data.login_time.replace(/-/g, '/').replace(/(\.\d+)?/g, '')).valueOf()
    state.loginTime = localStorage.loginTime
    var lastlogin
    if (data.last_login_at) {
      lastlogin = new Date(data.last_login_at.replace(/-/g, '/').replace(/(\.\d+)?/g, '')).valueOf()
    } else {
      lastlogin = 0
    }
    var userData = { 'lastPractice': new Date(data.last_practice.replace(/-/g, '/').replace(/(\.\d+)?/g, '')).valueOf(),
      'continuePractice': data.continue_practice,
      'practicedToday': (new Date().getTime() - new Date(parseInt(localStorage.lastPractice)).getTime()) / 1000 < 86400,
      'lastLoginAt': lastlogin }
    localStorage.userData = JSON.stringify(userData)
    console.log(JSON.stringify(data.oss_auth))
    sessionStorage.OssCredential = JSON.stringify(data.oss_auth)
  },
  setAvatar (state, data) {
    if (data.error === '03') {
      localStorage.avatar = require('../../../assets/EditPersonalInfo/wo.png')
    } else {
      let files = new window.File([data], data.name, { type: data.type })
      state.currentUser.avatar = window.URL.createObjectURL(files)
      localStorage.avatar = state.currentUser.avatar
    }
  },
  updateAvatar (state, data) {
    state.currentUser.avatarFile = data
    state.currentUser.avatar = window.URL.createObjectURL(data)
  },
  loginStart (state) {
    state.loginEngaging = true
  },
  loginEnd (state) {
    state.loginEngaging = false
  }
}

const actions = {
  userLogin ({ dispatch, commit }, data) {
    axios.post(loginAPI, {
      'email': data.email,
      'password': data.password
    })
      .then((response) => {
        if (response.data.error === '01') {
          Confirm.confirm(i18n.t('Auth.multipleLogin'))
            .then(() => {
              axios.post(confirmLoginAPI, {
                'email': data.email,
                'password': data.password
              })
                .then((response) => {
                  dispatch('continueLogin', response)
                })
                .catch(function (error) {
                  console.log(error)
                })
            })
        } else {
          dispatch('continueLogin', response)
        }
      })
      .catch(function (error) {
        remove()
        console.log(error)
      })
  },
  userLoginWithNumber ({ dispatch, commit }, data) {
    commit('loginStart')
    axios.post(loginWithNumberAPI, {
      'number': data.userNumber,
      'password': data.password
    })
      .then((response) => {
        if (response.data.error === '01') {
          Confirm.confirm(i18n.t('Auth.multipleLogin'))
            .then(() => {
              axios.post(confirmLoginWithNumberAPI, {
                'number': data.userNumber,
                'password': data.password
              })
                .then((response) => {
                  /** */
                  dispatch('continueLogin', response)
                  commit('resource/setResourceTexts', response.data.resourcesAndNews.resourceTexts, { root: true })
                  commit('resource/setResources', response.data.resourcesAndNews.resources, { root: true })
                  commit('resource/setAvatar', response.data.resourcesAndNews.avatar, { root: true })
                  commit('setAllowSpeechInput', response.data.allow_speech_input)
                  commit('vocabularyPractice/setIsUpgraded', response.data.is_upgraded, { root: true })
                  // commit('resource/setNews', response.data.resourcesAndNews.news, { root: true })
                })
                .catch(function (error) {
                  console.log(error)
                })
            })
        } else {
          console.log('here:', response)
          dispatch('continueLogin', response)
          commit('resource/setResourceTexts', response.data.resourcesAndNews.resourceTexts, { root: true })
          commit('resource/setResources', response.data.resourcesAndNews.resources, { root: true })
          commit('resource/setAvatar', response.data.resourcesAndNews.avatar, { root: true })
          commit('setAllowSpeechInput', response.data.allow_speech_input)
          commit('vocabularyPractice/setIsUpgraded', response.data.is_upgraded, { root: true })
          // commit('resource/setNews', response.data.resourcesAndNews.news, { root: true })
        }
      })
      .catch(function (error) {
        remove()
        commit('loginEnd')
        console.log(error)
      })
  },
  getAvatar (context) {
    axios.post(getAvatarAPI, {
      'id': localStorage.id
    }, {
      responseType: 'blob'
    })
      .then(function (response) {
        context.commit('setAvatar', response.data)
      })
      .catch(function (error) {
        context.commit('reset')
        console.log(error)
      })
  },
  async userLogout (context) {
    await axios.post(logoutAPI)
      .then(function (response) {
        context.commit('reset')
      })
      .catch(function (error) {
        context.commit('reset')
        console.log(error)
      })
  },
  submitFullData (context, newData) {
    axios.post(fullfillDataAPI, {
      'newData': newData
    })
      .then((response) => {
        router.replace({
          name: 'home'
        })
      })
      .catch((response) => {
        console.log(response)
      })
  },
  userProfile (context) {
    return axios.post(myProfileAPI, {
      'email': localStorage.email
    })
      .then(function (response) {
        context.commit('resetEdit', response.data.data)
        context.commit('set', response.data.data)
      })
  },
  updateData (context, formData) {
    return axios.post(updateAPI, formData,
      {
        transformRequest: [function (newData, headers) {
          return newData
        }]
      })
  },
  refreshToken () {
    return axios.post(refreshTokenAPI)
  },
  async firstPracticed () {
    if (!localStorage.practicedToday) {
      await axios.post(firstPracticedAPI)
    }
  },
  continueLogin ({ dispatch, commit }, response) {
    if (response.data.error === '02') {
      Alert.alert(i18n.t('Auth.loginFailed'))
      commit('loginEnd')
    } else if (response.data.error === '04') {
      commit('setToken', response.data.token)
      commit('set', response.data.user_data)
      commit('afterLogin', response.data)
      if (response.data.grade_id !== 18) {
        router.push({
          name: 'fullfillInfo'
        })
      }
      commit('loginEnd')
    } else if (response.data.error === '05') {
      Alert.alert(i18n.t('AppLayout.accountExpire'))
      commit('loginEnd')
    } else if (response.data.error === '06') {
      Alert.alert(i18n.t('AppLayout.accountFrozen'))
      commit('loginEnd')
    } else {
      dispatch('successLogin', response)
    }
  },
  successLogin ({ dispatch, commit }, response) {
    commit('setToken', response.data.token)
    commit('afterLogin', response.data)
    router.push({
      name: 'home'
    })
    dispatch('welcome')
    commit('loginEnd')
  },
  welcome ({ state }) {
    let lastPractice = parseInt(getUser().lastPractice)
    let continuePractice = parseInt(getUser().continuePractice)
    let expiryDate = state.currentUser.expiryDate
    let expiryIn = Math.floor(((new Date(parseInt(expiryDate)).getTime() - new Date().getTime()) / 1000) / 86400)
    if (expiryIn < 30) {
      Alert.alert(i18n.t('AppLayout.expiryIn', [expiryIn]))
    }
    if (lastPractice < 1000000000000) {
      Alert.alert(i18n.t('AppLayout.welcomeFirstTime'))
    } else if (expiryIn < 30) {
      Alert.alert(i18n.t('AppLayout.expiryIn', [expiryIn]))
    } else if ((new Date().getTime() - new Date(parseInt(lastPractice)).getTime()) / 1000 < 86400) {
      Alert.alert(i18n.t('AppLayout.continieAndToday', [continuePractice]))
    } else if ((new Date().getTime() - new Date(parseInt(lastPractice)).getTime()) / 1000 < 86400 * 2) {
      Alert.alert(i18n.t('AppLayout.continueButNotToday', [continuePractice]))
    } else {
      Alert.alert(i18n.t('AppLayout.noPractice', [Math.floor(((new Date().getTime() - new Date(parseInt(lastPractice)).getTime()) / 1000) / 86400)]))
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
